import { ReactNode } from 'react';
import { Radius, Spacings } from '@picsart/cascade';
import View from '@picsart/view/View';

import useStyles from '../styles';

const PreviewModalImageBox = ({ children }: {children: ReactNode}) => {
  const classes = useStyles();

  return (
    <View padding={Spacings.s16}>
      <View className={classes.imageBoxWrapper} borderRadius={Radius.r16}>
        <View className={classes.imageBox}>
          { children }
        </View>
      </View>
    </View>
  );
};

export default PreviewModalImageBox;
